<div class="blog-image-container">
  <img phImage [images]="images" />
</div>
